import React from "react";
var __jsx = React.createElement;
import { useTranslation } from "react-i18next";
import { Skeleton } from "@/components/skeleton";

/** A single encounter row placeholder across the table columns. */
function RowSkeleton() {
  return /*#__PURE__*/React.createElement("div", {
    className: "flex items-start gap-4 border-t border-sds-base-default px-4 py-4 first:border-t-0"
  }, /*#__PURE__*/React.createElement(Skeleton, {
    className: "h-4 w-4"
  }), /*#__PURE__*/React.createElement("div", {
    className: "flex flex-1 flex-col gap-2"
  }, /*#__PURE__*/React.createElement(Skeleton, {
    className: "h-4 w-40"
  }), /*#__PURE__*/React.createElement(Skeleton, {
    className: "h-3 w-28"
  }), /*#__PURE__*/React.createElement(Skeleton, {
    className: "h-5 w-24 rounded-sds-full"
  })), /*#__PURE__*/React.createElement(Skeleton, {
    className: "h-4 w-32"
  }), /*#__PURE__*/React.createElement(Skeleton, {
    className: "h-4 w-28"
  }), /*#__PURE__*/React.createElement(Skeleton, {
    className: "h-7 w-12 rounded-sds-200"
  }));
}

/** Placeholder mirroring the encounters table while data loads. */
export function EncountersSkeleton() {
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/React.createElement("div", {
    role: "status",
    "aria-busy": "true",
    className: "overflow-hidden rounded-sds-300 border border-sds-base-default bg-sds-base-default"
  }, /*#__PURE__*/React.createElement("span", {
    className: "sr-only"
  }, t("loading")), /*#__PURE__*/React.createElement("div", {
    className: "border-b border-sds-base-default bg-sds-base-secondary px-4 py-3"
  }, /*#__PURE__*/React.createElement(Skeleton, {
    className: "h-3 w-40"
  })), [0, 1, 2, 3, 4].map(function (row) {
    return /*#__PURE__*/React.createElement(RowSkeleton, {
      key: row
    });
  }));
}